<template>
  <NuxtLink
    v-if="Object.keys(data).length"
    :to="link"
    class="provider-preview"
    :class="{ 'is-outline' : isOutline }"
  >
    <div class="provider-preview__wrap">
      <div v-if="dataLabel" class="provider-preview__top">
        <UiBadge
          size="small"
          :icon-url="`${$config.cloudUrl}${dataLabel.iconUrl}`"
          :text="dataLabel.nameUa"
          :style="{
            color: dataLabel.textColor,
            backgroundColor: dataLabel.backgroundColor,
          }"
        />
      </div>
      <div class="provider-preview__img-wrap">
        <img
          v-lazy="$config.cloudUrl + data.iconUrlBig"
          :src="$pixel"
          :alt="data.name"
          class="provider-preview__img"
          width="60"
          height="60"
        />
      </div>
      <UiText
        :text="data.name"
        font="components-button-medium"
        color="button-grey-text-color"
        class="provider-preview__title"
      />
    </div>
  </NuxtLink>
</template>

<script>
import { ENUM_CATEGORY } from '@/components/Lobby/enum.js'

export default {
  name: 'CardProvider',
  props: {
    data: { type: Object, default: () => ({}) },
    isOutline: { type: Boolean },
  },
  computed: {
    link() {
      return this.localePath(`/${ENUM_CATEGORY.PROVIDERS.TERM}/${this.data?.term}`)
    },
    dataLabel() {
      return this.data?.labels?.length ? this.data.labels[0] : ''
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped></style>
